export type QueryValue = string | number | boolean | null | undefined | string[]
export type QueryParams = Record<string, QueryValue>

export function withQuery(path: string, params?: QueryParams): string {
  if (!params) {
    return path
  }

  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === '') {
      continue
    }
    if (Array.isArray(value)) {
      for (const item of value) search.append(`${key}[]`, item)
      continue
    }
    search.set(key, String(value))
  }

  const query = search.toString()
  return query ? `${path}?${query}` : path
}

type PathParam = string | number

type PathParams<Pattern extends string> = Pattern extends `${string}:${string}/${infer Rest}`
  ? [PathParam, ...PathParams<`/${Rest}`>]
  : Pattern extends `${string}:${string}`
    ? [PathParam]
    : []

export type RouteHelper<Pattern extends string> = (
  ...args: [...PathParams<Pattern>, QueryParams?]
) => string

// Builds a path helper from a Rails path pattern (without `(.:format)`). The placeholders become positional
// arguments in order, followed by optional query params. test/inertia_route_mirrors_test.rb checks each
// pattern against the Rails route named in the `// mirrors` comment above it.
export function route<Pattern extends string>(pattern: Pattern): RouteHelper<Pattern> {
  return (...args) => {
    const values = [...args]
    const path = pattern.replace(/:\w+/g, () => encodeURIComponent(String(values.shift())))
    return withQuery(path, values[0] as QueryParams | undefined)
  }
}

// mirrors frontend_root
export const rootPath = route('/')
